import { useEffect, useState } from "react";
import {
  DashBoardForminput,
  PasswordInput,
} from "../components/ui/dashboardForms";
import { useForm, SubmitHandler } from "react-hook-form";
import { LoginButton } from "../components/ui/loginButton";
import { useNavigate } from "react-router-dom";
import "./features.css";
import routesName from "../constants/routesName";
import constants from "../constants";
import { combinedRegex, emailRegex } from "../utils/regex";
import { jwtDecode } from "jwt-decode";
import { useAppDispatch } from "../redux/store";
import { getLogin } from "../redux/loginreducer";
import { useSelector } from "react-redux";
import { LoadingSpinner } from "../components/ui/loadinSpinner";
import { LoginFormDataType, accessTokenType } from "../modals/IloginCard";
import axios from "axios";
import { resetLoginState } from "../redux/loginslice";
import logo from "../assests/icons/doxor.png";
import UserAuditDetails from "../utils/userAuditDetails";
import DetectDevice from "../utils/detectDevice";
import CryptoJS from "crypto-js";
export default function LoginCard() {
  const navigate = useNavigate();
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<LoginFormDataType>();
  const dispatch = useAppDispatch();
  const loginData = useSelector((data: any) => data.login);
  const { osVersion, operatingSystem, ipAddress } = UserAuditDetails();
  const deviceType = DetectDevice();
  const userDetailsValue = watch("userDetails");

  const AES_KEY = '2dc41670ehdjurl1jdhu76yhtf6d48bb';
  const AES_IV = '1208987836506021';
  const encryptString = (plainText: string) => {
    const keyUtf8 = CryptoJS.enc.Utf8.parse(AES_KEY || "");
    const ivUtf8 = CryptoJS.enc.Utf8.parse(AES_IV || "");
    const encrypted = CryptoJS.AES.encrypt(plainText, keyUtf8, { iv: ivUtf8 });
    return encrypted.toString();
  };
  const onSubmit: SubmitHandler<LoginFormDataType> = async (data) => {





    const isEmail = userDetailsValue.match(emailRegex);

    const userData = {
      [isEmail ? "email" : "phone"]: isEmail
        ? userDetailsValue.toLowerCase()
        : userDetailsValue,
      password: watch("password"),
      appSourceType: "customermanagement",
      moduleType: "login",
      os: operatingSystem,
      ipAddress: ipAddress,
      imeiNumber: "",
      osVersion: osVersion,
      macAddress: "",
      model: "",
      userAction: "Login",
      device: deviceType,
      auditDate: new Date().toISOString(),
    };
    dispatch(getLogin(userData));
  };

  useEffect(() => {
    if (loginData.status === "success") {
      const decodeToken: accessTokenType = jwtDecode(
        loginData?.userdetails?.accessToken || ""
      );
      if (loginData?.userdetails?.passwordreset === true) {
        sessionStorage.setItem(
          constants.accessTokenText,
          loginData?.userdetails?.accessToken
        );
        sessionStorage.setItem(constants.isLoginLocalStorage, "true");
        navigate(routesName.resetPasswordPage, {
          state: {
            email: decodeToken?.email,
            passwordreset: loginData?.userdetails?.passwordreset,
            accessToken: loginData?.userdetails?.accessToken,
          },
        });
      } else {
        // navigate("/dashBoard");

        axios.defaults.headers[
          "Authorization"
        ] = `Bearer ${loginData?.userdetails?.accessToken}`;

        const url = process.env.REACT_APP_MA_LOGIN_NEW_URL || ''; // Replace with actual URL

        const headers = {
          'accept': '*/*',
          'Content-Type': 'application/json;odata.metadata=minimal;odata.streaming=true',
        };

        const data = {
          email: watch("userDetails"),     // Replace with actual email
          password: encryptString(watch("password")),  // Replace with actual password
        };

        axios.post(url, data, { headers })
          .then(response => {
            sessionStorage.setItem(
              constants.accessTokenText,
              loginData?.userdetails?.accessToken
            );
            sessionStorage.setItem(constants.isLoginLocalStorage, "true");
            sessionStorage.setItem('newlogin', response?.data?.access_token);
            sessionStorage.setItem('maLoginCredentials', JSON.stringify(data));
            window.location.reload();
          })
          .catch(error => {
            setEmailError("");
            setPasswordError("");
            console.log('error:', error);
            setErrorMessage('UserID or Password Incorrect');
            // window.location.reload();
          });

      }

    }
    if (loginData.status === "failed") {
      const emailError =
        loginData?.error?.data?.status === 401
          ? "Email ID/Mobile Number is not registered with us"
          : "";

      const passwordError =
        loginData?.error?.data?.message === "Wrong password"
          ? "Password is wrong"
          : "";

      setEmailError(emailError);
      setPasswordError(passwordError);
      if (!emailError && !passwordError) {
        setErrorMessage(
          loginData?.error?.data?.message ?? "something went wrong"
        );
      }
    }
  }, [loginData]);

  useEffect(() => {
    return () => {
      dispatch(resetLoginState());
    };
  }, []);

  console.log(process.env.REACT_APP_MA_LOGIN_URL, "urlValue");

  return (
    <>
      <div className="h-screen flex items-center justify-center">
        <div className="bg-white h-auto sm:w-[470px] flex items-center justify-center rounded-lg pt-[40px] pb-[56px] px-[56px]">
          <form onSubmit={handleSubmit(onSubmit)} className="w-[100%]">
            <div className="flex justify-center">
              <img src={logo} className="h-[70px] w-[auto] mb-[50px]" />
            </div>
            <div className="">
              <DashBoardForminput
                label={constants.userNameText}
                id="userDetails"
                type="text"
                register={{
                  ...register("userDetails", {
                    required: constants.userNameRequired,
                    pattern: {
                      value: combinedRegex,
                      message: "Invalid Email ID or Phone Number",
                    },
                    onChange: () => {
                      setEmailError("");
                      setErrorMessage("");
                    },
                  }),
                }}
                errorMessage={errors?.userDetails?.message || emailError}
                error={emailError || errorMessage ? true : false}
              />
            </div>
            <div className="mt-10 ">
              <PasswordInput
                label={constants.passwordText}
                id="password"
                type="password"
                register={{
                  ...register("password", {
                    required: constants.passwordRequired,
                    onChange: () => {
                      setPasswordError("");
                      setErrorMessage("");
                    },
                  }),
                }}
                errorMessage={errors?.password?.message || passwordError}
                error={passwordError || errorMessage ? true : false}
              />
            </div>
            <div className="flex justify-end mt-3">
              <button
                type="button"
                data-testid="forgot_button"
                className="text-12 font-semibold text-blue-300"
                onClick={() => navigate(routesName.forgotPasswordPage)}
              >
                {constants.forgotPasswordText}
              </button>
            </div>
            <div className="text-center">
              <span className="text-error text-12 font-medium">
                {errorMessage}
              </span>
            </div>
            <div className="flex justify-center pt-8">
              <LoginButton
                name={
                  loginData.isLoading ? (
                    <span className="flex items-center gap-2">
                      <LoadingSpinner width="w-4" height="h-4" /> Loading...
                    </span>
                  ) : (
                    constants.loginText
                  )
                }
                width="w-[100%]"
              />
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
